import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import {
  FirstLayer,
  SecondLayer,
  FourthLayer,
  FifthLayer,
  ThirdLayer,
  SixthLayer,
  SeventhLayer,
  EightLayer,
  NinthLayer,
  TenthLayer,
  EleventhLayer,
} from '../../components/data/Home/Layers/index';
import ContactUs from '../../components/common/ContactUs';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <FirstLayer />
      <SecondLayer />
      <ThirdLayer />
      <FourthLayer />
      <FifthLayer />
      <SixthLayer />
      <SeventhLayer />
      <EightLayer />
      <NinthLayer />
      <TenthLayer />
      <EleventhLayer />
      <ContactUs />
    </Box>
  );
};

export default Home;
